// @flow
import * as React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

import { Flex, Checkbox } from 'components/common'
import { useI18n } from '~/core/i18n'

type DisableableControllerProps = {
  Controller: React.ComponentType<any>,
  name: string,
  placeholder?: string,
  defaultValue?: any,
  disableValue?: any
}

const DisableableController = ({
  Controller,
  placeholder,
  disableValue = null,
  defaultValue = '',
  name,
  ...props
}: DisableableControllerProps) => {
  const [msg] = useI18n()
  const { control, setValue } = useFormContext()
  const controllerValue = useWatch({ control, name })
  const isDisabled = controllerValue === disableValue

  return (
    <Flex alignCenter>
      <Controller
        defaultValue={defaultValue}
        isDisabled={isDisabled}
        name={name}
        placeholder={isDisabled ? msg('callcenter.queues.content.disabled') : placeholder}
        wrapperProps={{
          style: {
            flex: 1
          }
        }}
        {...props}
      />
      <Checkbox
        checked={isDisabled}
        label={<strong style={{ marginLeft: 4 }}>{msg('callcenter.queues.content.disabled')}</strong>}
        style={{
          marginLeft: '3rem',
          marginBottom: '-2rem'
        }}
        onChange={({ target }) => setValue(name, target.checked ? disableValue : defaultValue, { shouldDirty: true })}
      />
    </Flex>
  )
}

export { DisableableController }
